export default __webpack_public_path__ + "static/media/suzuki1.0afed7e6.png";